import { render, staticRenderFns } from "./talkList.vue?vue&type=template&id=5d785e11"
import script from "./talkList.vue?vue&type=script&lang=js"
export * from "./talkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports